<template>
  <div>
    
    <van-cell-group v-for="(c, i) in questionnaire" :key="i">
      <van-field
         v-if="c.type == 'select'"
        v-model="append[c.title].value"
        readonly
        required
        clickable
        :label="c.title"
        :placeholder="c.title"
        :rules="[rule_required]"
        @click="ShowPopub(i)"
      />
      <van-field
        v-else
        
        v-model="append[c.title].value"
        type="text"
        :label="c.title"
        :placeholder="c.title"
      />
    </van-cell-group>
    <!-- <div style="margin: 16px">
        <van-row>
          <van-col span="12"
            ><van-button
             
              round
              block
              @click.prevent="$emit('handlerStep', -1)"
              >上一步</van-button
            >
           
          </van-col>
          <van-col span="12">
            <van-button
              round
              block
              type="info"
              @click.prevent="$emit('handlerStep', 1)"
              >提交</van-button
            >
            
          </van-col>
        </van-row>
      </div> -->
    <!-- 地区选择弹窗 -->
    <van-popup v-model="showPopup" position="bottom">
      <van-picker
        title="请选择"
        show-toolbar
        :columns="popupList"
        @cancel="showPopup = false"
        @confirm="onPopupConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "appendfaq",
  props: {
    appendinfo: {
      type: Array,
      default: [],
    },
    questionnaire: {
      type: Array,
      default: [],
    },
    append: {
      type: Object,
    },
  },
  data() {
    return {
     
      showPopup: false,
      popubIndex: -1,
      popupList: [],
      rule_required: {
        trigger: "onBlur",
        required: true,
        message: "请补充信息",
      },
    };
  },
  created() {
    
    //this.$nextTick(() => {
    console.log(this.questionnaire);
    for (var i in this.questionnaire) {
      let q = this.questionnaire[i];
      let title = q.title;
      this.$set(this.append, q.title, { title: title });
    }
    console.log(this.append);
    for (var i in this.appendinfo) {
      let q = this.appendinfo[i];
      this.append[q.title].value = this.appendinfo[i].value;
    }
    //});
  },
  methods: {
    ShowPopub(index) {
      this.showPopup = true;
      this.popubIndex = index;
      this.popupList = this.questionnaire[index].list;
    },
    onPopupConfirm(value) {
      var title = this.questionnaire[this.popubIndex].title;
      this.append[title] = { title, value };
      this.showPopup = false;
    },
  },
  components: {},
};
</script>
<style scoped lang="less">
#userMessage {
  box-sizing: border-box;
  padding: 10px;
  background: #fff;
}
</style>